export default __webpack_public_path__ + "static/media/HeartRate.cf9dcbd1.svg";